import { Component, Inject, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { trigger, style, animate, transition, query, stagger } from '@angular/animations';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';

@Component({
    selector: 'app-offer-search-dialog',
    templateUrl: './offer-search-dialog.component.html',
    styleUrl: './offer-search-dialog.component.scss',
    animations: [
        trigger('stagger', [
            transition('* => *', [
                query(':enter', [
                    style({ opacity: 0, transform: 'scale(0.3) translateY(45px)' }),
                    stagger(200, [
                        animate('400ms ease-in', style({ opacity: 0.7, transform: 'scale(1) translateY(-60px)' })),
                        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
                    ])
                ], { optional: true })
            ])
        ])
    ],
    standalone: false
})

export class OfferSearchDialogComponent {
	$storage: any;
	total: number = 0;

	offers: any[] = [];
	selectedOffers: any[] = [];
	searchCriteria: string;

	@ViewChild('list') list: MatSelectionList;


	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<OfferSearchDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public orderService: OrderService,
	) {
		this.$storage = this.orderService.$storage;
		this.offers = this.orderService.getCatalogItemsAsFlatArray();
	}

	cancel() {
		this.dialogRef.close();
	}

	searchTimeout;
	showStagger = true;
	onSearchChange(ev) {
		clearTimeout(this.searchTimeout);
		this.showStagger = false;
		if (!ev || ev.trim().length < 2) {
			this.selectedOffers = [];
			return;
		}
		const searchString = ev.trim().toLowerCase();
		this.searchTimeout = setTimeout(() => {
			this.showStagger = true;
			this.selectedOffers = this.offers.filter(offer => {
				if (offer.name.toLowerCase().includes(searchString)) return true;
				if (offer.description && offer.description.toLowerCase().includes(searchString)) return true;
			});
		}, 200);
	}

	menuItemClick(offer, ev) {
		this.dialogRef.close({
			offer: offer,
			ev: ev
		});
	}

}

